import { Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";

import useGetAccountStatus from "@/hooks/requests/t2Pay/use-get-account-status";
import { T2PayHomeMessages } from "@/messages/platforms/talk2PayHome/t2pay-home.messages";

import AccountStatusCard from "./components/accountStatusCard";

type Props = {
  messages: T2PayHomeMessages;
};

function CadastralSituation({ messages }: Props) {
  const { data: accountStatus, isLoading } = useGetAccountStatus();

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, lg: 12 }}>
        {isLoading ? (
          <Skeleton variant="rectangular" width="100%" height={150} />
        ) : (
          accountStatus && <AccountStatusCard messages={messages} status={accountStatus} />
        )}
      </Grid>
    </Grid>
  );
}

export default CadastralSituation;
